import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    standalone: false
})
export class TagComponent implements OnInit {

  @Input() text!: string;
  @Input() selected?: boolean;
  @Input() disabled?: boolean;

  constructor() { }

  ngOnInit() {}

}
